// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8ecnH","title":"styles_title__3eFfL"};